import store from '@/store';

export const useDirectStore = () => {
  return store.$direct;
};
